import { default as indexEFScSbTUhBMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualiza-tu-plan/index.vue?macro=true";
import { default as datos_45adicionalesHx75WbVRVpMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/datos-adicionales.vue?macro=true";
import { default as finalizarYH3yOTZeH6Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/finalizar.vue?macro=true";
import { default as indexu1Ot4DlQPAMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/index.vue?macro=true";
import { default as metodo_45pagoyj5VvjCzSUMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/metodo-pago.vue?macro=true";
import { default as seleccionar_45planSnvK1hjTLvMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/seleccionar-plan.vue?macro=true";
import { default as email_45verified7skqqAG5WrMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/email-verified.vue?macro=true";
import { default as completeCqAW2mTpeaMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/finish-sign-up/complete.vue?macro=true";
import { default as select_45plan49lM2SIxnrMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/finish-sign-up/select-plan.vue?macro=true";
import { default as forgot_45passwordYEZcUy4376Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/forgot-password.vue?macro=true";
import { default as not_45allowedpceS6PBdnAMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/not-allowed.vue?macro=true";
import { default as not_45found8jZjjwIrCiMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/not-found.vue?macro=true";
import { default as paypal_45payment_45savedx4iwZOvOvmMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/paypal-payment-saved.vue?macro=true";
import { default as recover_45passwordPDes68Q6lsMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/recover-password.vue?macro=true";
import { default as sign_45innrCWgiD5VWMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/sign-in.vue?macro=true";
import { default as sign_45upUkfeQp9YgjMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/sign-up.vue?macro=true";
import { default as additional_45dataFvedw4fdXfMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/additional-data.vue?macro=true";
import { default as complete8EJOasAHe3Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/complete.vue?macro=true";
import { default as payment_45methodithih6Ahe9Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/payment-method.vue?macro=true";
import { default as select_45planjIygimz1LCMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/select-plan.vue?macro=true";
import { default as sign_45up2Fh6vuuH8vMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/sign-up.vue?macro=true";
import { default as verify_45emailKBsb8LVZikMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/verify-email.vue?macro=true";
import { default as verify_45emailATrSN6TPQEMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/verify-email.vue?macro=true";
import { default as landingvG4tuqDIeJMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/claims/landing.vue?macro=true";
import { default as dashboarduAVIlAo4dOMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/dashboard.vue?macro=true";
import { default as detallee6VMFABbtUMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/descargas-publicas/[hash]/detalle.vue?macro=true";
import { default as listJSwE93bzteMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/faqs/list.vue?macro=true";
import { default as indexFzFJopxA44Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/index.vue?macro=true";
import { default as download_45_91hash_936xxK8uIrAXMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/judicial-precedents/download-[hash].vue?macro=true";
import { default as listVsRaKzDu65Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/judicial-precedents/list.vue?macro=true";
import { default as public_45documents_45download_45registerY8i83BYe8TMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/landings/public-documents-download-register.vue?macro=true";
import { default as list2aHUoetdhOMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/news/list.vue?macro=true";
import { default as profilebOZAJHIXTeMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/profile.vue?macro=true";
import { default as download_45_91hash_93cLkIo7pMx4Meta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/public-documents/download-[hash].vue?macro=true";
import { default as listxqWxMioSpLMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/public-documents/list.vue?macro=true";
import { default as listT7UXmL3fzqMeta } from "C:/Users/Viktor/Development/asufin-panel-v2/pages/tickets/list.vue?macro=true";
export default [
  {
    name: indexEFScSbTUhBMeta?.name ?? "actualiza-tu-plan",
    path: indexEFScSbTUhBMeta?.path ?? "/actualiza-tu-plan",
    meta: indexEFScSbTUhBMeta || {},
    alias: indexEFScSbTUhBMeta?.alias || [],
    redirect: indexEFScSbTUhBMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualiza-tu-plan/index.vue").then(m => m.default || m)
  },
  {
    name: datos_45adicionalesHx75WbVRVpMeta?.name ?? "actualizar-plan-datos-adicionales",
    path: datos_45adicionalesHx75WbVRVpMeta?.path ?? "/actualizar-plan/datos-adicionales",
    meta: datos_45adicionalesHx75WbVRVpMeta || {},
    alias: datos_45adicionalesHx75WbVRVpMeta?.alias || [],
    redirect: datos_45adicionalesHx75WbVRVpMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/datos-adicionales.vue").then(m => m.default || m)
  },
  {
    name: finalizarYH3yOTZeH6Meta?.name ?? "actualizar-plan-finalizar",
    path: finalizarYH3yOTZeH6Meta?.path ?? "/actualizar-plan/finalizar",
    meta: finalizarYH3yOTZeH6Meta || {},
    alias: finalizarYH3yOTZeH6Meta?.alias || [],
    redirect: finalizarYH3yOTZeH6Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/finalizar.vue").then(m => m.default || m)
  },
  {
    name: indexu1Ot4DlQPAMeta?.name ?? "actualizar-plan",
    path: indexu1Ot4DlQPAMeta?.path ?? "/actualizar-plan",
    meta: indexu1Ot4DlQPAMeta || {},
    alias: indexu1Ot4DlQPAMeta?.alias || [],
    redirect: indexu1Ot4DlQPAMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/index.vue").then(m => m.default || m)
  },
  {
    name: metodo_45pagoyj5VvjCzSUMeta?.name ?? "actualizar-plan-metodo-pago",
    path: metodo_45pagoyj5VvjCzSUMeta?.path ?? "/actualizar-plan/metodo-pago",
    meta: metodo_45pagoyj5VvjCzSUMeta || {},
    alias: metodo_45pagoyj5VvjCzSUMeta?.alias || [],
    redirect: metodo_45pagoyj5VvjCzSUMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/metodo-pago.vue").then(m => m.default || m)
  },
  {
    name: seleccionar_45planSnvK1hjTLvMeta?.name ?? "actualizar-plan-seleccionar-plan",
    path: seleccionar_45planSnvK1hjTLvMeta?.path ?? "/actualizar-plan/seleccionar-plan",
    meta: seleccionar_45planSnvK1hjTLvMeta || {},
    alias: seleccionar_45planSnvK1hjTLvMeta?.alias || [],
    redirect: seleccionar_45planSnvK1hjTLvMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/actualizar-plan/seleccionar-plan.vue").then(m => m.default || m)
  },
  {
    name: email_45verified7skqqAG5WrMeta?.name ?? "auth-email-verified",
    path: email_45verified7skqqAG5WrMeta?.path ?? "/auth/email-verified",
    meta: email_45verified7skqqAG5WrMeta || {},
    alias: email_45verified7skqqAG5WrMeta?.alias || [],
    redirect: email_45verified7skqqAG5WrMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/email-verified.vue").then(m => m.default || m)
  },
  {
    name: completeCqAW2mTpeaMeta?.name ?? "auth-finish-sign-up-complete",
    path: completeCqAW2mTpeaMeta?.path ?? "/auth/finish-sign-up/complete",
    meta: completeCqAW2mTpeaMeta || {},
    alias: completeCqAW2mTpeaMeta?.alias || [],
    redirect: completeCqAW2mTpeaMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/finish-sign-up/complete.vue").then(m => m.default || m)
  },
  {
    name: select_45plan49lM2SIxnrMeta?.name ?? "auth-finish-sign-up-select-plan",
    path: select_45plan49lM2SIxnrMeta?.path ?? "/auth/finish-sign-up/select-plan",
    meta: select_45plan49lM2SIxnrMeta || {},
    alias: select_45plan49lM2SIxnrMeta?.alias || [],
    redirect: select_45plan49lM2SIxnrMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/finish-sign-up/select-plan.vue").then(m => m.default || m)
  },
  {
    name: forgot_45passwordYEZcUy4376Meta?.name ?? "auth-forgot-password",
    path: forgot_45passwordYEZcUy4376Meta?.path ?? "/auth/forgot-password",
    meta: forgot_45passwordYEZcUy4376Meta || {},
    alias: forgot_45passwordYEZcUy4376Meta?.alias || [],
    redirect: forgot_45passwordYEZcUy4376Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: not_45allowedpceS6PBdnAMeta?.name ?? "auth-not-allowed",
    path: not_45allowedpceS6PBdnAMeta?.path ?? "/auth/not-allowed",
    meta: not_45allowedpceS6PBdnAMeta || {},
    alias: not_45allowedpceS6PBdnAMeta?.alias || [],
    redirect: not_45allowedpceS6PBdnAMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/not-allowed.vue").then(m => m.default || m)
  },
  {
    name: not_45found8jZjjwIrCiMeta?.name ?? "auth-not-found",
    path: not_45found8jZjjwIrCiMeta?.path ?? "/auth/not-found",
    meta: not_45found8jZjjwIrCiMeta || {},
    alias: not_45found8jZjjwIrCiMeta?.alias || [],
    redirect: not_45found8jZjjwIrCiMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/not-found.vue").then(m => m.default || m)
  },
  {
    name: paypal_45payment_45savedx4iwZOvOvmMeta?.name ?? "auth-paypal-payment-saved",
    path: paypal_45payment_45savedx4iwZOvOvmMeta?.path ?? "/auth/paypal-payment-saved",
    meta: paypal_45payment_45savedx4iwZOvOvmMeta || {},
    alias: paypal_45payment_45savedx4iwZOvOvmMeta?.alias || [],
    redirect: paypal_45payment_45savedx4iwZOvOvmMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/paypal-payment-saved.vue").then(m => m.default || m)
  },
  {
    name: recover_45passwordPDes68Q6lsMeta?.name ?? "auth-recover-password",
    path: recover_45passwordPDes68Q6lsMeta?.path ?? "/auth/recover-password",
    meta: recover_45passwordPDes68Q6lsMeta || {},
    alias: recover_45passwordPDes68Q6lsMeta?.alias || [],
    redirect: recover_45passwordPDes68Q6lsMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/recover-password.vue").then(m => m.default || m)
  },
  {
    name: sign_45innrCWgiD5VWMeta?.name ?? "auth-sign-in",
    path: sign_45innrCWgiD5VWMeta?.path ?? "/auth/sign-in",
    meta: sign_45innrCWgiD5VWMeta || {},
    alias: sign_45innrCWgiD5VWMeta?.alias || [],
    redirect: sign_45innrCWgiD5VWMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/sign-in.vue").then(m => m.default || m)
  },
  {
    name: sign_45upUkfeQp9YgjMeta?.name ?? "auth-sign-up",
    path: sign_45upUkfeQp9YgjMeta?.path ?? "/auth/sign-up",
    meta: sign_45upUkfeQp9YgjMeta || {},
    alias: sign_45upUkfeQp9YgjMeta?.alias || [],
    redirect: sign_45upUkfeQp9YgjMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/sign-up.vue").then(m => m.default || m)
  },
  {
    name: additional_45dataFvedw4fdXfMeta?.name ?? "auth-v2-finish-sign-up-additional-data",
    path: additional_45dataFvedw4fdXfMeta?.path ?? "/auth/v2/finish-sign-up/additional-data",
    meta: additional_45dataFvedw4fdXfMeta || {},
    alias: additional_45dataFvedw4fdXfMeta?.alias || [],
    redirect: additional_45dataFvedw4fdXfMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/additional-data.vue").then(m => m.default || m)
  },
  {
    name: complete8EJOasAHe3Meta?.name ?? "auth-v2-finish-sign-up-complete",
    path: complete8EJOasAHe3Meta?.path ?? "/auth/v2/finish-sign-up/complete",
    meta: complete8EJOasAHe3Meta || {},
    alias: complete8EJOasAHe3Meta?.alias || [],
    redirect: complete8EJOasAHe3Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/complete.vue").then(m => m.default || m)
  },
  {
    name: payment_45methodithih6Ahe9Meta?.name ?? "auth-v2-finish-sign-up-payment-method",
    path: payment_45methodithih6Ahe9Meta?.path ?? "/auth/v2/finish-sign-up/payment-method",
    meta: payment_45methodithih6Ahe9Meta || {},
    alias: payment_45methodithih6Ahe9Meta?.alias || [],
    redirect: payment_45methodithih6Ahe9Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/payment-method.vue").then(m => m.default || m)
  },
  {
    name: select_45planjIygimz1LCMeta?.name ?? "auth-v2-finish-sign-up-select-plan",
    path: select_45planjIygimz1LCMeta?.path ?? "/auth/v2/finish-sign-up/select-plan",
    meta: select_45planjIygimz1LCMeta || {},
    alias: select_45planjIygimz1LCMeta?.alias || [],
    redirect: select_45planjIygimz1LCMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/finish-sign-up/select-plan.vue").then(m => m.default || m)
  },
  {
    name: sign_45up2Fh6vuuH8vMeta?.name ?? "auth-v2-sign-up",
    path: sign_45up2Fh6vuuH8vMeta?.path ?? "/auth/v2/sign-up",
    meta: sign_45up2Fh6vuuH8vMeta || {},
    alias: sign_45up2Fh6vuuH8vMeta?.alias || [],
    redirect: sign_45up2Fh6vuuH8vMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/sign-up.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailKBsb8LVZikMeta?.name ?? "auth-v2-verify-email",
    path: verify_45emailKBsb8LVZikMeta?.path ?? "/auth/v2/verify-email",
    meta: verify_45emailKBsb8LVZikMeta || {},
    alias: verify_45emailKBsb8LVZikMeta?.alias || [],
    redirect: verify_45emailKBsb8LVZikMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/v2/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailATrSN6TPQEMeta?.name ?? "auth-verify-email",
    path: verify_45emailATrSN6TPQEMeta?.path ?? "/auth/verify-email",
    meta: verify_45emailATrSN6TPQEMeta || {},
    alias: verify_45emailATrSN6TPQEMeta?.alias || [],
    redirect: verify_45emailATrSN6TPQEMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/auth/verify-email.vue").then(m => m.default || m)
  },
  {
    name: landingvG4tuqDIeJMeta?.name ?? "claims-landing",
    path: landingvG4tuqDIeJMeta?.path ?? "/claims/landing",
    meta: landingvG4tuqDIeJMeta || {},
    alias: landingvG4tuqDIeJMeta?.alias || [],
    redirect: landingvG4tuqDIeJMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/claims/landing.vue").then(m => m.default || m)
  },
  {
    name: dashboarduAVIlAo4dOMeta?.name ?? "dashboard",
    path: dashboarduAVIlAo4dOMeta?.path ?? "/dashboard",
    meta: dashboarduAVIlAo4dOMeta || {},
    alias: dashboarduAVIlAo4dOMeta?.alias || [],
    redirect: dashboarduAVIlAo4dOMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: detallee6VMFABbtUMeta?.name ?? "descargas-publicas-hash-detalle",
    path: detallee6VMFABbtUMeta?.path ?? "/descargas-publicas/:hash()/detalle",
    meta: detallee6VMFABbtUMeta || {},
    alias: detallee6VMFABbtUMeta?.alias || [],
    redirect: detallee6VMFABbtUMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/descargas-publicas/[hash]/detalle.vue").then(m => m.default || m)
  },
  {
    name: listJSwE93bzteMeta?.name ?? "faqs-list",
    path: listJSwE93bzteMeta?.path ?? "/faqs/list",
    meta: listJSwE93bzteMeta || {},
    alias: listJSwE93bzteMeta?.alias || [],
    redirect: listJSwE93bzteMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/faqs/list.vue").then(m => m.default || m)
  },
  {
    name: indexFzFJopxA44Meta?.name ?? "index",
    path: indexFzFJopxA44Meta?.path ?? "/",
    meta: indexFzFJopxA44Meta || {},
    alias: indexFzFJopxA44Meta?.alias || [],
    redirect: indexFzFJopxA44Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: download_45_91hash_936xxK8uIrAXMeta?.name ?? "judicial-precedents-download-hash",
    path: download_45_91hash_936xxK8uIrAXMeta?.path ?? "/judicial-precedents/download-:hash()",
    meta: download_45_91hash_936xxK8uIrAXMeta || {},
    alias: download_45_91hash_936xxK8uIrAXMeta?.alias || [],
    redirect: download_45_91hash_936xxK8uIrAXMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/judicial-precedents/download-[hash].vue").then(m => m.default || m)
  },
  {
    name: listVsRaKzDu65Meta?.name ?? "judicial-precedents-list",
    path: listVsRaKzDu65Meta?.path ?? "/judicial-precedents/list",
    meta: listVsRaKzDu65Meta || {},
    alias: listVsRaKzDu65Meta?.alias || [],
    redirect: listVsRaKzDu65Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/judicial-precedents/list.vue").then(m => m.default || m)
  },
  {
    name: public_45documents_45download_45registerY8i83BYe8TMeta?.name ?? "landings-public-documents-download-register",
    path: public_45documents_45download_45registerY8i83BYe8TMeta?.path ?? "/landings/public-documents-download-register",
    meta: public_45documents_45download_45registerY8i83BYe8TMeta || {},
    alias: public_45documents_45download_45registerY8i83BYe8TMeta?.alias || [],
    redirect: public_45documents_45download_45registerY8i83BYe8TMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/landings/public-documents-download-register.vue").then(m => m.default || m)
  },
  {
    name: list2aHUoetdhOMeta?.name ?? "news-list",
    path: list2aHUoetdhOMeta?.path ?? "/news/list",
    meta: list2aHUoetdhOMeta || {},
    alias: list2aHUoetdhOMeta?.alias || [],
    redirect: list2aHUoetdhOMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/news/list.vue").then(m => m.default || m)
  },
  {
    name: profilebOZAJHIXTeMeta?.name ?? "profile",
    path: profilebOZAJHIXTeMeta?.path ?? "/profile",
    meta: profilebOZAJHIXTeMeta || {},
    alias: profilebOZAJHIXTeMeta?.alias || [],
    redirect: profilebOZAJHIXTeMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: download_45_91hash_93cLkIo7pMx4Meta?.name ?? "public-documents-download-hash",
    path: download_45_91hash_93cLkIo7pMx4Meta?.path ?? "/public-documents/download-:hash()",
    meta: download_45_91hash_93cLkIo7pMx4Meta || {},
    alias: download_45_91hash_93cLkIo7pMx4Meta?.alias || [],
    redirect: download_45_91hash_93cLkIo7pMx4Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/public-documents/download-[hash].vue").then(m => m.default || m)
  },
  {
    name: listxqWxMioSpLMeta?.name ?? "public-documents-list",
    path: listxqWxMioSpLMeta?.path ?? "/public-documents/list",
    meta: listxqWxMioSpLMeta || {},
    alias: listxqWxMioSpLMeta?.alias || [],
    redirect: listxqWxMioSpLMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/public-documents/list.vue").then(m => m.default || m)
  },
  {
    name: listT7UXmL3fzqMeta?.name ?? "tickets-list",
    path: listT7UXmL3fzqMeta?.path ?? "/tickets/list",
    meta: listT7UXmL3fzqMeta || {},
    alias: listT7UXmL3fzqMeta?.alias || [],
    redirect: listT7UXmL3fzqMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-panel-v2/pages/tickets/list.vue").then(m => m.default || m)
  }
]